module.exports = __webpack_public_path__ + "static/gcash_shop-online-fcaa86f3366961875f03740c91fa284c.gif";